import {ReactNode} from "react";
import {Box} from "@mui/material";
import {createStyles, makeStyles} from "@mui/styles";
import {Theme} from "@mui/material/styles";
import CommonCssStyles from "../../css/CommonCssStyles";


export interface PageContentProps {
    children: ReactNode | ReactNode[];
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        controlPageSegment: CommonCssStyles.getControlPageSegmentStyles(theme),
    })
);

export default function PageContent({children}: Readonly<PageContentProps>) {
    const classes = useStyles();

    return (
        <Box className={classes.controlPageSegment}>
            {children}
        </Box>
    );
}